import {
  Directive,
  HostListener,
  HostBinding,
  Output,
  EventEmitter,
} from '@angular/core';

@Directive({
  selector: '[fileDragDrop]',
  standalone: false
})
export class FileDragNDropDirective {
  @Output() private filesChangeEmiter: EventEmitter<File[]> =
    new EventEmitter();
  @HostBinding('style.width') private width = '100px';
  @HostBinding('style.height') private height = '100px';
  @HostBinding('style.border') private borderStyle = '1px dashed';
  @HostBinding('style.border-color') private borderColor = '#b4b4b4';
  @HostBinding('style.border-radius') private borderRadius = '10px';
  @HostBinding('style.margin-right') private marginRight = '10px';
  @HostBinding('style.margin-bottom') private marginBottom = '10px';


  @HostListener('dragover', ['$event']) public onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.borderColor = 'cadetblue';
    this.borderStyle = '3px solid';
  }

  @HostListener('dragleave', ['$event']) public onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.borderColor = '#696D7D';
    this.borderStyle = '1px dashed';
  }

  @HostListener('drop', ['$event']) public onDrop(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.borderColor = '#696D7D';
    this.borderStyle = '1px dashed';
    let files = evt.dataTransfer.files;
    let valid_files: Array<File> = files;
    this.filesChangeEmiter.emit(valid_files);
  }
}
